import { loadCartProductsModule } from "../modules/loadCartProductsModule";

export function loadCartProducts(cart) {

    const elements = {
        cartProductsHolder: document.getElementById("cart-products"),
    }

    loadCartProductsModule.on("load", () => {
        elements.cartProductsHolder.classList.add("blurred", "loading-text")
    })

    loadCartProductsModule.on("create", (data) => {
        elements.cartProductsHolder.innerHTML = data
    })
    loadCartProductsModule.on("loadComplete", () => {
        loadCartProductsModule.showContent();
    })

    loadCartProductsModule.on("show", () => {
        elements.cartProductsHolder.classList.remove("blurred", "loading-text")

        addProductDeletion(cart);
    })


    loadCartProductsModule.on("error", (message) => {console.error(message) })
    loadCartProductsModule.on("urlError", (message) => {})


    setTimeout(() => {
        loadCartProductsModule.getCart(cart);
    }, 300)

}

/**
 * 
 * @param {Cart} cart 
 */
function addProductDeletion(cart) {
    let productsInCart = document.querySelectorAll(".cart-product");
    for(let product of productsInCart) {
        let deleter = product.querySelector(".delete-cart-product")
        let product365 = deleter.dataset.product365;
        let addons = deleter.dataset.addons.split(','); addons.pop();
        let places = deleter.dataset.places;
        
        deleter.addEventListener("click", (e) => {
            e.preventDefault()

            //let cartProduct = cart.searchProductByParameters(product365, addons, places)
            product.remove();
            cart.deleteProductByParameters(product365, addons, places)
            cart.saveCartToLocalStorage(cart)
        })

    }
}
